export var EqActionResult;
(function (EqActionResult) {
    EqActionResult[EqActionResult["Error"] = 0] = "Error";
    EqActionResult[EqActionResult["Success"] = 1] = "Success";
})(EqActionResult || (EqActionResult = {}));
//# sourceMappingURL=action.js.map